import React from "react";
import { Button } from "./CustomButtonStyles";
import Spinner from "../Common/Spinner";
import CheckRender from "../Common/CheckRender";
import useEmpresa from "../../hooks/useEmpresa";

const CustomButton = ({
  onClick,
  textColor,
  hoverTextColor,
  bgColor,
  hoverColor,
  label,
  icon,
  isLoading,
  loadingColor,
  width,
  height,
  border,
  weight,
  fontSize,
  disabled,
  type,
}) => {
  const empresa = useEmpresa();

  return (
    <Button
      type={type || "button"}
      onClick={onClick}
      backGroundColor={bgColor || empresa?.COLOR_PRINCIPAL}
      hoverColor={hoverColor || empresa?.COLOR_SECUNDARIO}
      textColor={textColor}
      hoverTextColor={hoverTextColor}
      font={empresa?.LETRA_PRINCIPAL}
      width={width}
      height={height}
      border={border}
      weight={weight}
      fontSize={fontSize}
      disabled={disabled}
    >
      <CheckRender allowed={isLoading}>
        <Spinner
          size={20}
          colorBorderTop={loadingColor || empresa?.COLOR_PRINCIPAL}
        />
      </CheckRender>

      <CheckRender allowed={!isLoading}>
        <CheckRender allowed={icon}>{icon}</CheckRender>
        <CheckRender allowed={label}>{label}</CheckRender>
      </CheckRender>
    </Button>
  );
};

export default CustomButton;
